__turbopack_context__.v({
  "copiedNoText": "copyToClipboardButton-module-scss-module__hn16eG__copiedNoText",
  "iconOutline": "copyToClipboardButton-module-scss-module__hn16eG__iconOutline",
});
